// ==========================================
// ITNI - ERP Stock & Tracabilite
// Donnees fictives alignees sur le cahier des charges
// ==========================================

export const entreprise = {
  nom: 'ITNI',
  raisonSociale: 'ITNI - Installations Electriques TP',
  slogan: 'ERP Stock & Tracabilite',
};

export const utilisateurConnecte = {
  id: 'USR-001',
  prenom: 'Laura',
  nom: 'Delattre',
  email: 'l.delattre@itni.fr',
  role: 'Administrateur',
  entrepotParDefaut: 'Entrepot central Lyon',
};

// ---------- CLIENTS (Marches) ----------
// "Les Marches sont renommes en Clients"
export const clients = [
  {
    id: 'CLI-001',
    nom: 'Metropole Grand Lyon',
    codeMarche: 'MGL-2026-018',
    typeMarche: 'Marche public',
    adresse: '20 rue du Lac, 69002 Lyon',
    contact: 'Severine Morel',
    email: 's.morel@grandlyon.fr',
    telephone: '04 26 99 00 01',
    chantiers: [
      { id: 'CHT-001', nom: 'Tunnel A45 - base vie electrique', statut: 'en_cours', avancement: 62 },
      { id: 'CHT-002', nom: 'Station tramway T9 - zone Est', statut: 'en_cours', avancement: 34 },
    ],
  },
  {
    id: 'CLI-002',
    nom: 'Conseil Departemental du Rhone',
    codeMarche: 'CD69-2025-094',
    typeMarche: 'Marche public',
    adresse: '29 Cours de la Liberte, 69003 Lyon',
    contact: 'Jerome Perret',
    email: 'j.perret@rhone.fr',
    telephone: '04 72 61 50 00',
    chantiers: [
      { id: 'CHT-003', nom: 'Echangeur Nord - local technique', statut: 'en_cours', avancement: 78 },
      { id: 'CHT-004', nom: 'Viaduc Rive Sud - maintenance', statut: 'livre', avancement: 100 },
    ],
  },
  {
    id: 'CLI-003',
    nom: 'SYTRAL Mobilites',
    codeMarche: 'SYT-2026-T9-EL',
    typeMarche: 'Marche public',
    adresse: '21 boulevard Vivier-Merle, 69003 Lyon',
    contact: 'Ines Laurent',
    email: 'i.laurent@sytral.fr',
    telephone: '04 26 00 30 00',
    chantiers: [
      { id: 'CHT-005', nom: 'Ligne Tram T9 - postes stations', statut: 'etude', avancement: 12 },
    ],
  },
];

// ---------- FOURNISSEURS ----------
// Avec compte reference, documents legaux + dates de validite
export const fournisseurs = [
  {
    id: 'FOU-001',
    nom: 'Electra Distribution',
    contact: 'Claire Vignal',
    email: 'c.vignal@electra-distribution.fr',
    telephone: '04 72 18 40 20',
    adresse: 'ZI La Plaine, 69680 Chassieu',
    siret: '532 114 987 00015',
    documents: [
      { type: 'KBIS', dateValidite: '2026-05-18', statut: 'a_renouveler' },
      { type: 'RIB', dateValidite: '2027-01-01', statut: 'conforme' },
      { type: 'Contrat sous-traitance', dateValidite: '2026-12-31', statut: 'conforme' },
      { type: 'Declaration sous-traitance', dateValidite: '2026-06-30', statut: 'conforme' },
    ],
    nbProduits: 47,
    nbCommandes: 28,
  },
  {
    id: 'FOU-002',
    nom: 'Cablix Industrie',
    contact: 'Mathieu Gorce',
    email: 'm.gorce@cablix.fr',
    telephone: '03 87 44 98 12',
    adresse: '12 rue des Forges, 57070 Metz',
    siret: '412 557 023 00034',
    documents: [
      { type: 'KBIS', dateValidite: '2027-01-30', statut: 'conforme' },
      { type: 'RIB', dateValidite: '2027-03-15', statut: 'conforme' },
      { type: 'Declaration sous-traitance', dateValidite: '2026-09-10', statut: 'conforme' },
    ],
    nbProduits: 62,
    nbCommandes: 41,
  },
  {
    id: 'FOU-003',
    nom: 'Nordic Automation',
    contact: 'Anders Holm',
    email: 'a.holm@nordic-auto.eu',
    telephone: '01 45 67 90 14',
    adresse: 'Tour CB21, 92800 Puteaux',
    siret: '799 432 118 00027',
    documents: [
      { type: 'KBIS', dateValidite: '2026-11-02', statut: 'conforme' },
      { type: 'RIB', dateValidite: '2027-02-20', statut: 'conforme' },
      { type: 'Contrat sous-traitance', dateValidite: '2026-04-30', statut: 'a_renouveler' },
    ],
    nbProduits: 23,
    nbCommandes: 14,
  },
];

// ---------- EQUIPEMENTS (Produits) ----------
// Type: Materiel / Prestation / Licence
// Avec references fournisseurs (marque/modele), handles et amont/aval
export const equipements = [
  {
    id: 'EQ-001',
    libelle: 'Armoire TGBT 1600A',
    type: 'Materiel',
    marque: 'Schneider',
    modele: 'Prisma Plus TGBT1600',
    description: 'Tableau general basse tension 1600A pour locaux techniques',
    references: [
      { fournisseurId: 'FOU-001', reference: 'ED-TGBT-1600-001', prixAchat: 18400, delai: '6 semaines' },
    ],
    handles: { synoptique: 2, detaille: 24 },
    sens: 'aval',
    attributs: { puissance: '1600A', tension: '400V', protection: 'IP55' },
  },
  {
    id: 'EQ-002',
    libelle: 'Transformateur sec 630 kVA',
    type: 'Materiel',
    marque: 'ABB',
    modele: 'RESIBLOC 630',
    description: 'Transformateur sec pour local technique',
    references: [
      { fournisseurId: 'FOU-003', reference: 'NA-TRS-630-RB', prixAchat: 26700, delai: '10 semaines' },
    ],
    handles: { synoptique: 2, detaille: 6 },
    sens: 'amont',
    attributs: { puissance: '630 kVA', refroidissement: 'Air', isolation: 'F' },
  },
  {
    id: 'EQ-003',
    libelle: 'Coffret de distribution IP65',
    type: 'Materiel',
    marque: 'Legrand',
    modele: 'Atlantic 800x600',
    description: 'Coffret de distribution etanche pour chantier',
    references: [
      { fournisseurId: 'FOU-001', reference: 'ED-COF-IP65-800', prixAchat: 860, delai: '2 semaines' },
      { fournisseurId: 'FOU-002', reference: 'CX-IP65-LG-800', prixAchat: 830, delai: '3 semaines' },
    ],
    handles: { synoptique: 2, detaille: 12 },
    sens: 'aval',
    attributs: { protection: 'IP65', dimensions: '800x600x300', materiau: 'Polyester' },
  },
  {
    id: 'EQ-004',
    libelle: 'Cable puissance U-1000 R2V 4G10',
    type: 'Materiel',
    marque: 'Nexans',
    modele: 'U-1000 R2V 4G10',
    description: 'Cable puissance 4 conducteurs cuivre',
    references: [
      { fournisseurId: 'FOU-002', reference: 'CX-R2V-4G10', prixAchat: 21.5, delai: '1 semaine' },
    ],
    handles: { synoptique: 1, detaille: 4 },
    sens: 'passif',
    attributs: { section: '4G10mm2', conducteur: 'Cuivre', tension: 'U-1000' },
  },
  {
    id: 'EQ-005',
    libelle: 'Prestation mise en service tableau',
    type: 'Prestation',
    marque: 'ITNI',
    modele: 'MES-TGBT',
    description: 'Intervention technique mise en service et essais',
    references: [
      { fournisseurId: 'FOU-001', reference: 'PRES-MES-TGBT', prixAchat: 3200, delai: 'A planifier' },
    ],
    handles: { synoptique: 0, detaille: 0 },
    sens: 'passif',
    attributs: { duree: '1 journee', certification: 'Oui' },
  },
  {
    id: 'EQ-006',
    libelle: 'Licence supervision SCADA annuelle',
    type: 'Licence',
    marque: 'Siemens',
    modele: 'WinCC Pro',
    description: 'Licence annuelle logiciel supervision',
    references: [
      { fournisseurId: 'FOU-003', reference: 'NA-LIC-WCC-PRO', prixAchat: 4800, delai: '1 jour' },
    ],
    handles: { synoptique: 0, detaille: 0 },
    sens: 'passif',
    attributs: { duree: '12 mois', postes: '5 utilisateurs' },
  },
];

// ---------- COMMANDES FOURNISSEURS ----------
// Cycle: creation -> depart_usine -> reception_bl -> installation
export const commandes = [
  {
    id: 'CMD-2026-0089',
    fournisseurId: 'FOU-001',
    fournisseurNom: 'Electra Distribution',
    date: '2026-04-05',
    chantier: 'Tunnel A45 - base vie electrique',
    clientId: 'CLI-001',
    etape: 'installation',
    montantHT: 62050,
    entrepot: 'Entrepot central Lyon',
    lignes: [
      { equipementId: 'EQ-001', libelle: 'Armoire TGBT 1600A', quantite: 2, prixUnit: 18400, numerosSerie: ['TGBT-A45-0018', 'TGBT-A45-0019'] },
      { equipementId: 'EQ-003', libelle: 'Coffret de distribution IP65', quantite: 8, prixUnit: 860, numerosSerie: [] },
      { equipementId: 'EQ-005', libelle: 'Prestation mise en service tableau', quantite: 3, prixUnit: 3200, numerosSerie: [] },
    ],
    bl: { numero: 'BL-2026-0201', date: '2026-04-08', entrepotDestination: 'Entrepot central Lyon' },
  },
  {
    id: 'CMD-2026-0078',
    fournisseurId: 'FOU-003',
    fournisseurNom: 'Nordic Automation',
    date: '2026-03-18',
    chantier: 'Echangeur Nord - local technique',
    clientId: 'CLI-002',
    etape: 'reception_bl',
    montantHT: 72060,
    entrepot: 'Entrepot Saint-Priest',
    lignes: [
      { equipementId: 'EQ-002', libelle: 'Transformateur sec 630 kVA', quantite: 2, prixUnit: 26700, numerosSerie: [] },
      { equipementId: 'EQ-003', libelle: 'Coffret de distribution IP65', quantite: 7, prixUnit: 860, numerosSerie: [] },
      { equipementId: 'EQ-006', libelle: 'Licence supervision SCADA annuelle', quantite: 1, prixUnit: 4800, numerosSerie: [] },
    ],
    bl: { numero: 'BL-2026-0189', date: '2026-03-22', entrepotDestination: 'Entrepot Saint-Priest' },
  },
  {
    id: 'CMD-2026-0095',
    fournisseurId: 'FOU-002',
    fournisseurNom: 'Cablix Industrie',
    date: '2026-04-12',
    chantier: 'Ligne Tram T9 - postes stations',
    clientId: 'CLI-003',
    etape: 'depart_usine',
    montantHT: 40441,
    entrepot: 'Entrepot Vaulx-en-Velin',
    lignes: [
      { equipementId: 'EQ-004', libelle: 'Cable puissance U-1000 R2V 4G10', quantite: 650, prixUnit: 21.5, numerosSerie: [] },
      { equipementId: 'EQ-003', libelle: 'Coffret de distribution IP65', quantite: 9, prixUnit: 830, numerosSerie: [] },
    ],
    bl: null,
  },
  {
    id: 'CMD-2026-0104',
    fournisseurId: 'FOU-002',
    fournisseurNom: 'Cablix Industrie',
    date: '2026-04-20',
    chantier: 'Station tramway T9 - zone Est',
    clientId: 'CLI-001',
    etape: 'creation',
    montantHT: 28540,
    entrepot: 'Entrepot central Lyon',
    lignes: [
      { equipementId: 'EQ-004', libelle: 'Cable puissance U-1000 R2V 4G10', quantite: 1250, prixUnit: 21.5, numerosSerie: [] },
    ],
    bl: null,
  },
];

export const etapesCommande = [
  { id: 'creation', label: 'Creation', description: 'Saisie de la commande aupres du fournisseur' },
  { id: 'depart_usine', label: 'Depart usine', description: 'Equipements identifies et suivis individuellement' },
  { id: 'reception_bl', label: 'Reception BL', description: 'Entree en stock + marquage n BL sur chaque equipement' },
  { id: 'installation', label: 'Installation chantier', description: 'Association numero de serie + BL sur site' },
];

// ---------- ENTREPOTS ----------
export const entrepots = [
  {
    id: 'ENT-01',
    nom: 'Entrepot central Lyon',
    adresse: 'Parc logistique Corbas, 69960 Corbas',
    responsable: 'Pierre Garnier',
    nbEquipements: 248,
    capacite: 400,
  },
  {
    id: 'ENT-02',
    nom: 'Entrepot Saint-Priest',
    adresse: '17 rue de l Industrie, 69800 Saint-Priest',
    responsable: 'Maelle Rey',
    nbEquipements: 176,
    capacite: 250,
  },
  {
    id: 'ENT-03',
    nom: 'Entrepot Vaulx-en-Velin',
    adresse: '6 avenue Marcel Cachin, 69120 Vaulx-en-Velin',
    responsable: 'Nadir Benali',
    nbEquipements: 119,
    capacite: 180,
  },
];

export const mouvementsStock = [
  { id: 'MVT-441', date: '2026-04-13T09:35', equipement: 'Coffret de distribution IP65', quantite: 6, origine: 'Entrepot Saint-Priest', destination: 'Entrepot central Lyon', utilisateur: 'S. Andre', commentaire: 'Preparation lot tunnel A45' },
  { id: 'MVT-442', date: '2026-04-15T14:20', equipement: 'Cable U-1000 R2V 4G10', quantite: 120, origine: 'Entrepot Vaulx-en-Velin', destination: 'Entrepot central Lyon', utilisateur: 'L. Perrin', commentaire: 'Reequilibrage stock' },
  { id: 'MVT-443', date: '2026-04-18T08:05', equipement: 'Transformateur sec 630 kVA', quantite: 1, origine: 'Entrepot Saint-Priest', destination: 'Chantier Echangeur Nord', utilisateur: 'C. Rey', commentaire: 'Depart terrain' },
  { id: 'MVT-444', date: '2026-04-19T11:15', equipement: 'Armoire TGBT 1600A', quantite: 2, origine: 'Entrepot central Lyon', destination: 'Chantier Tunnel A45', utilisateur: 'L. Delattre', commentaire: 'Livraison equipements numerotes' },
];

// ---------- TRAçabilite equipements ----------
// Commande -> Fournisseur -> BL -> N serie -> Chantier
export const tracabilite = [
  {
    numeroSerie: 'TGBT-A45-0018',
    equipement: 'Armoire TGBT 1600A',
    commande: 'CMD-2026-0089',
    fournisseur: 'Electra Distribution',
    bl: 'BL-2026-0201',
    chantier: 'Tunnel A45 - base vie electrique',
    dateInstallation: '2026-04-18',
    etape: 'Installe',
    reserves: 'Aucune',
  },
  {
    numeroSerie: 'TGBT-A45-0019',
    equipement: 'Armoire TGBT 1600A',
    commande: 'CMD-2026-0089',
    fournisseur: 'Electra Distribution',
    bl: 'BL-2026-0201',
    chantier: 'Tunnel A45 - base vie electrique',
    dateInstallation: '2026-04-19',
    etape: 'Essais',
    reserves: 'Controle thermique a J+7',
  },
];

// ---------- ATTRIBUTS EQUIPEMENTS ----------
// Standard (par defaut) ou Confidentiel (admin uniquement)
export const attributsEquipements = [
  { nom: 'Marque', confidentiel: false, description: 'Marque figee couple marque/modele' },
  { nom: 'Modele', confidentiel: false, description: 'Modele figee couple marque/modele' },
  { nom: 'Puissance', confidentiel: false, description: 'Puissance nominale' },
  { nom: 'Tension', confidentiel: false, description: 'Tension d utilisation' },
  { nom: 'Code maintenance', confidentiel: true, description: 'Code technique de maintenance constructeur' },
  { nom: 'Identifiant VPN', confidentiel: true, description: 'Identifiant distant supervision' },
  { nom: 'Adresse IP', confidentiel: true, description: 'Adresse IP sur le reseau chantier' },
];

// ---------- CABLES (bibliotheque) ----------
// Chaque cable: couleur globale + fils indexes (couleur par fil)
export const cables = [
  {
    id: 'CAB-001',
    nom: 'Cable puissance 4G10',
    couleurGlobale: 'Noir',
    hexGlobal: '#111827',
    fils: [
      { index: 1, couleur: 'Jaune/Vert', hex: '#84CC16' },
      { index: 2, couleur: 'Bleu', hex: '#3B82F6' },
      { index: 3, couleur: 'Marron', hex: '#78350F' },
      { index: 4, couleur: 'Noir', hex: '#111827' },
    ],
  },
  {
    id: 'CAB-002',
    nom: 'Cable commande 12 fils',
    couleurGlobale: 'Gris',
    hexGlobal: '#9CA3AF',
    fils: [
      { index: 1, couleur: 'Blanc', hex: '#E5E7EB' },
      { index: 2, couleur: 'Bleu ciel', hex: '#7DD3FC' },
      { index: 3, couleur: 'Vert', hex: '#10B981' },
      { index: 4, couleur: 'Orange', hex: '#F97316' },
      { index: 5, couleur: 'Rouge', hex: '#EF4444' },
      { index: 6, couleur: 'Violet', hex: '#8B5CF6' },
    ],
  },
  {
    id: 'CAB-003',
    nom: 'Cable signal blinde 8 paires',
    couleurGlobale: 'Bleu',
    hexGlobal: '#2563EB',
    fils: [
      { index: 1, couleur: 'Blanc / Bleu', hex: '#BFDBFE' },
      { index: 2, couleur: 'Bleu', hex: '#2563EB' },
      { index: 3, couleur: 'Blanc / Orange', hex: '#FED7AA' },
      { index: 4, couleur: 'Orange', hex: '#F97316' },
    ],
  },
];

// Raccordements types: couple (equipement, cable) -> preparation reutilisable
export const raccordementsTypes = [
  {
    id: 'RAC-001',
    equipementId: 'EQ-001',
    equipementLibelle: 'Armoire TGBT 1600A',
    cableId: 'CAB-001',
    cableNom: 'Cable puissance 4G10',
    nbFils: 4,
    branchements: '4 fils sur handles 1 a 4 (arrivee TGBT cote amont)',
  },
  {
    id: 'RAC-002',
    equipementId: 'EQ-002',
    equipementLibelle: 'Transformateur sec 630 kVA',
    cableId: 'CAB-001',
    cableNom: 'Cable puissance 4G10',
    nbFils: 4,
    branchements: 'Sortie transfo -> handle detaille 1/2/3 + terre',
  },
];

// ---------- ETAPES PLAN DE CABLAGE ----------
export const etapesCablage = [
  { id: 1, titre: 'Gestion des cables', description: 'Couleur globale + couleur indexee de chaque fil', statut: 'termine' },
  { id: 2, titre: 'Handles equipements', description: 'Handles synoptique (1 par cable) + handles detaille (1 par fil)', statut: 'en_cours' },
  { id: 3, titre: 'Preparation equipement + cable', description: 'Modeles de raccordement reutilisables couple (equipement, cable)', statut: 'a_planifier' },
  { id: 4, titre: 'Construction des architectures', description: 'Architecture synoptique + architecture detaillee + raccordement auto amont/aval', statut: 'a_planifier' },
];

// ---------- PLAN D'IMPLEMENTATION ----------
// Pour la maquette: simples positions d equipements sur un plan
export const planImplementation = {
  chantier: 'Tunnel A45 - base vie electrique',
  equipementsPlaces: [
    { id: 'pl-1', equipementId: 'EQ-002', libelle: 'Transformateur 630 kVA', x: 12, y: 22, sens: 'amont' },
    { id: 'pl-2', equipementId: 'EQ-001', libelle: 'Armoire TGBT', x: 42, y: 32, sens: 'aval' },
    { id: 'pl-3', equipementId: 'EQ-003', libelle: 'Coffret IP65 A', x: 72, y: 18, sens: 'aval' },
    { id: 'pl-4', equipementId: 'EQ-003', libelle: 'Coffret IP65 B', x: 72, y: 52, sens: 'aval' },
    { id: 'pl-5', equipementId: 'EQ-003', libelle: 'Coffret IP65 C', x: 60, y: 76, sens: 'aval' },
  ],
};

// ---------- HELPERS ----------
export const formatMontant = (montant) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(montant);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const statutLabel = {
  en_cours: 'En cours',
  livre: 'Livre',
  etude: 'En etude',
  termine: 'Termine',
  a_planifier: 'A planifier',
  conforme: 'Conforme',
  a_renouveler: 'A renouveler',
};
